import { render, staticRenderFns } from "./NoticeComponent.vue?vue&type=template&id=28ad3eb7&scoped=true&"
import script from "./NoticeComponent.vue?vue&type=script&lang=ts&"
export * from "./NoticeComponent.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeComponent.vue?vue&type=style&index=0&id=28ad3eb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ad3eb7",
  null
  
)

export default component.exports